<template>
  <div class="d-flex-row space-between lg-row-to-col">
    <MasteryPickery
      :type="'currentMastery'"
      item-key="masteryBoost"
      :title="$t('calculators_common.current_mastery')"
      :description="$t('calculators_common.select_current_level')"
      :show-server="false"
      class="flex-5 flex-lg-10"
    />
    <DoubleRight />
    <MasteryPickery
      :type="'desiredMastery'"
      item-key="masteryBoost"
      :title="$t('calculators_common.desired_mastery')"
      :description="$t('calculators_common.select_desired_level')"
      :show-server="false"
      class="flex-5 flex-lg-10"
      :prev-rank="getDetails.currentMastery"
    />
  </div>
  <extra-option-picker :options="['server']" />
  <option-picker />
  <roles-picker />
  <champions-picker :select-only-one-champion="true" />
</template>

<script setup>
import ExtraOptionPicker from "./pickers/ExtraOptionPicker.vue";
import OptionPicker from "./pickers/OptionPicker.vue";
import RolesPicker from "./pickers/RolesPicker.vue";
import ChampionsPicker from "../commonpickers/ChampionsPicker.vue";
import DoubleRight from "~/components/icons/DoubleRight.vue";
import MasteryPickery from "./pickers/MasteryPickery.vue";
import { onMounted, watch } from "vue";
const {
  setDetails,
  setPlatform,
  setServer,
  setGameAndPack,
  clearCheckout,
  setOneHero,
  getDetails,
  setCalculating,
} = useCheckoutStore();

const gameStore = useGameStore();
const { currentGameSlug } = useGameComposable();

clearCheckout();
const handleDetails = () => {
  setDetails({
    currentMastery: 122,
    currentMasterySlab: 1,
    currentMasteryTitle: "Tier 1",
    desiredMastery: 124,
    desiredMasterySlab: 3,
    desiredMasteryTitle: "Tier 3",
  });

  setGameAndPack({
    game: gameStore.getGame.id,
    pack: gameStore.getGamePack.id,
    fullGame: gameStore.getGame,
    fullPack: gameStore.getGamePack,
  });
  gameStore
    .apiGetGameHeroes({
      gameSlug: currentGameSlug,
    })
    .then(() => {
      // if (gameStore.getGameHeroes) {
      //   setOneHero({
      //     championId: gameStore.getGameHeroes[0].id,
      //   });
      // }
    });

  setPlatform({
    platform: 1,
  });
  setServer(1);
};

handleDetails();
onNuxtReady(() => {
  setCalculating();
});
watch(
  () => gameStore.getGamePack,
  (newVal) => {
    setGameAndPack({
      game: gameStore.getGame.id,
      pack: newVal.id,
      fullGame: gameStore.getGame,
      fullPack: newVal,
    });
  }
);
</script>
